export default "__VITE_ASSET__CRKAxgV6__"